import { Button } from "core/components/form-controls";
import { AddIngredientByImageSwiperButton } from "modules/AiChef/components";
import BlackCamera from "../../../core/assets/icons/black-camera.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import { useGetHistory } from "../hooks/history";
import RecipeSuggestionItemLoading from "modules/Recipes/components/RecipeSuggestions/Loading";
import { _t } from "core/language";
import EmptyData from "core/components/EmptyData";
import { useEffect, useState } from "react";
import Items from "../components/History/Items";

const HistoryTab = () => {
  const { loading, data, loadMore, lastPage, params } = useGetHistory();
  console.log(data, "data111111");

  const [emptyData, setEmptyData] = useState(false);

  useEffect(() => {
    if (!data?.length && !loading && params?.page === 1) {
      setEmptyData(true);
    } else {
      setEmptyData(false);
    }
  }, [data]);
  const handleFetchMore = () => {
    console.log(lastPage, "handleFetchMore", params?.page);
    if (lastPage > params?.page) {
      loadMore();
    }
  };

  return (
    <div>
      <div className="flex justify-center">
        <AddIngredientByImageSwiperButton>
          <Button
            classBtn="md:w-auto !w-full [box-shadow:none!important] !rounded-[8px] font-medium !px-[18px] !py-[14px] !mb-[10px] border border-[#DDDDDD]"
            icon={BlackCamera}
            iconClassName="mr-2"
            rounded
            size="sm"
            label={_t('ingredient.history_take_photo')}
          />
        </AddIngredientByImageSwiperButton>
      </div>
      <div className="">
        <InfiniteScroll
          dataLength={data?.length || 0}
          next={handleFetchMore}
          hasMore={!!data?.length}
          loader={null}
          className=""
        >
          {(data?.length ? data : [])?.map((item: any, key: number) => (
            <Items key={key} item={item} />
          ))}
        </InfiniteScroll>
        {!data?.length && loading ? (
          <div className="grid grid-cols-2 gap-2">
            {Array.from(Array(params?.page === 1 ? 10 : 4).keys()).map(
              (e: number) => (
                <RecipeSuggestionItemLoading key={e} />
              )
            )}
          </div>
        ) : !data?.length && !loading && emptyData ? (
          <EmptyData message={_t("ingredient.history_no_data")} />
        ) : null}
      </div>
    </div>
  );
};

export default HistoryTab;
